import { TableHeadersType } from "../tableHeadersType";

export const SCHEDULING_USER_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "JOB TYPE",
    value: "job_type",
  },
  {
    label: "DETAILS",
    value: "job_description",
  },
  {
    label: "START DATE",
    value: "target_start_date",
  },

  {
    label: "TARGET END DATE",
    value: "target_end_date",
  },
  {
    label: "SCHEDULE STATUS",
    value: "schedule_status",
  },
  {
    label: "ACTION",
    value: "action",
  },
];
export const SCHEDULING_APPROVED_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "JOB TYPE",
    value: "job_type",
  },
  {
    label: "DETAILS",
    value: "job_description",
  },
  {
    label: "CLIENT",
    value: "client",
  },
  {
    label: "START DATE",
    value: "target_start_date",
  },

  {
    label: "TARGET END DATE",
    value: "target_end_date",
  },
  {
    label: "APPROVED HOURS",
    value: "total_hours",
  },
  {
    label: "SCHEDULE STATUS",
    value: "schedule_status",
  },
  {
    label: "ACTION",
    value: "action",
  },
];


export const SCHEDULING_APPROVAL_PENDING_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "JOB TYPE",
    value: "job_type",
  },
  {
    label: "DETAILS",
    value: "job_description",
  },
  {
    label: "CLIENT",
    value: "client",
  },
  {
    label: "START DATE",
    value: "target_start_date",
  },

  {
    label: "TARGET END DATE",
    value: "target_end_date",
  },
  {
    label: "SCHEDULE STATUS",
    value: "schedule_status",
  },
  {
    label: "ACTION",
    value: "action",
  },
];
export const SCHEDULING_MANAGER_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "EMPLOYEE NAME",
    value: "employee_name",
  },
  {
    label: "JOB TYPE",
    value: "job_type",
  },
  {
    label: "CLIENT",
    value: "client",
  },
  {
    label: "TARGET END DATE",
    value: "target_end_date",
  },
  {
    label: "ESTIMATED HOURS",
    value: "estimated_hours",
  },
  {
    label: "SCHEDULE STATUS",
    value: "status",
  },
  {
    label: "ACTION",
    value: "action",
  },
];

export const MAPPED_USER_TO_JOB_HEADERS: TableHeadersType[] = [
  {
    "label": "DATE",
    "value": "date",
  
  },
  {
    "label": "HOURS",
    "value": "hours",
  },
];
